import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EncuestaBlService } from './services/encuesta-bl.service';
import { EncuestaFinal } from 'src/app/shared/components/dialog/models/encuesta-final';
import * as moment from "moment";
import { FunctionsService } from 'src/app/shared/services/functions.service';
import { CHorario } from 'src/app/shared/components/horario-trabajo/horario.model';
import { UIService } from 'src/app/shared/services/ui.services';
import { SnackBarType } from 'src/app/shared/types/snackbar-type';
import { ListaTipoPregunta, Msjs, Msjs_Validations, PatternsRegex } from 'src/app/shared/cons/common';
import {
  trigger,
  state,
  style,
  animate,
  transition
  // ... puedes importar más funciones si las necesitas
} from '@angular/animations';
import { CEncuesta } from 'src/app/shared/components/formularios-encuesta/models/encuesta.model';
import { Icons } from 'src/app/shared/cons/icons';
import { CCliente } from 'src/app/shared/components/formularios-encuesta/models/cliente.model';
import { Utils } from 'src/app/shared/helpers/utils';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { RespuestaFormulario } from 'src/app/shared/components/formularios-encuesta/models/respuesta-formulario';
import { CabeceraRespuesta } from 'src/app/shared/components/formularios-encuesta/models/cabecera-respuesta';
import { SpinnerPageService } from 'src/app/shared/components/spinner-page/spinner-page.service';
@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.scss'],
  encapsulation: ViewEncapsulation.None,
    animations: [
      trigger('myInsertRemoveTrigger', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 })),
        ]),
        transition(':leave', [
          animate('500ms', style({ opacity: 0 }))
        ])
      ]),
    ]
})
export class EncuestaComponent implements OnInit {
    isLoadingFormulario:boolean = true;
    visibleEncuesta:boolean = false;
    readonly ListaTipoPregunta : typeof ListaTipoPregunta = ListaTipoPregunta;
    paramSubs!:Subscription;
    formularioId:string | null= null;
    formularioSb!:Subscription;    
    diasSemana:string[] = ["d", "l", "m", "x", "j", "v", "s"];
    formulario:EncuestaFinal = new EncuestaFinal();
    visible1:boolean = false;
    visible2:boolean = false;
    errorMsg:string=Msjs.MSJ_INFO_PREGUNTA_REQUERIDA;
    readonly Msjs_Validations: typeof Msjs_Validations = Msjs_Validations;
    respuesta:CEncuesta = new CEncuesta();
    validOpcionFlag:boolean = false;
    readonly Icons: typeof Icons = Icons;
    validBinaria:boolean =  false;
    validComentarioFlag:boolean = false;
    validDatosFlag:boolean = false;
    readonly PatternsRegex: typeof PatternsRegex = PatternsRegex;
    
    formularioStepGroup!: FormArray;
    form!: FormGroup;
    paginaErrorVisible:boolean=false;
    paginaErrorNoDisponible:boolean = false;
    //respuestas
    rsptaOpinion:string='';
    rsptaCliente:CCliente = new CCliente();
    onlyNumbers = Utils.InputOnlyNumbers;

  constructor(
    private route:ActivatedRoute,
    private router: Router,
    private encuestaBl: EncuestaBlService,
    private functionService: FunctionsService,
    private uiService: UIService,
    private fb: FormBuilder,
    private readonly spinnerPageService: SpinnerPageService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      steps: this.fb.array([]),
    });

    
    this.isLoadingFormulario = true;
    this.paramSubs = this.route.paramMap.subscribe(async params => {
      this.formularioId = params.get('id');
      if(this.formularioId!='' && this.formularioId!==null )      {
        this.formulario = (await this.encuestaBl.getFormularioExterno(this.formularioId) )as EncuestaFinal;
        if(this.formulario && this.formulario.encabezado.codigo_encuesta){
          const fechaServer = moment(await this.functionService.GetDateServer()).local().format();
          const fechaActual = new Date(fechaServer);
          const hora = fechaActual.getHours();        
          const dia = this.diasSemana[fechaActual.getDay()];
          this.isLoadingFormulario = false;          
          // validando si se puede llenar el formulario        
          const result = this.validandoFechaHora(this.formulario.encabezado.horario_disponible,dia, hora);
          if(!result){
            this.uiService.ShowSnackBar(SnackBarType.WARNING,Msjs.MSJ_ENCUESTA_NO_DISPONIBLE, 3000 );
            this.isLoadingFormulario = false;
            this.paginaErrorNoDisponible = true;
          }else{
            this.visibleEncuesta = true;
            this.visible1 = true;
            this.initSteps(); // Inicializa los pasos según el tipo de pregunta
    

          }

        }else{
            this.uiService.ShowSnackBar(SnackBarType.WARNING,Msjs.MSJ_ENCUESTA_NO_ENCONTRADA, 3000 );
            this.isLoadingFormulario = false;
            this.paginaErrorVisible = true;
        }   
      }
        


    });
  }

  get steps(): FormArray {
    return this.form.get('steps') as FormArray;
  }

 
  
  initSteps() {
    for (const prgta of this.formulario.tipo_pregunta) {
      switch (prgta.tipo_pregunta) {
        case ListaTipoPregunta.TipoPregunta[0].codigo:
          this.steps.push(this.fb.group({
            opcion: [null, Validators.required],
          }));
          break;

        case ListaTipoPregunta.TipoPregunta[1].codigo:
          this.steps.push(this.fb.group({
            respuesta_binaria: [null, Validators.required],
          }));
          break;

        case ListaTipoPregunta.TipoPregunta[2].codigo:
          this.steps.push(this.fb.group({
            satisfaccion: [null, Validators.required],
          }));
          break;

        case ListaTipoPregunta.TipoPregunta[3].codigo:
          this.steps.push(this.fb.group({
            comentario: ['', [
              Validators.required,
              Validators.minLength(10),
              Validators.maxLength(100),
              Validators.pattern(this.PatternsRegex.onlyWordSpanishNumberWithSpaceBlank)
            ]]
          }));
          break;

        case ListaTipoPregunta.TipoPregunta[4].codigo:
          this.steps.push(this.fb.group({
            nombres: ['', [Validators.required,Validators.minLength(3), Validators.maxLength(50), Validators.pattern(this.PatternsRegex.onlyCharsTwoWordsSpanish)]],
            apellido_paterno: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30), Validators.pattern(this.PatternsRegex.onlyCharsOneWordsSpanish)]],
            apellido_materno: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30), Validators.pattern(this.PatternsRegex.onlyCharsOneWordsSpanish)]],
            sexo: ['', Validators.required],
            correo_electronico: ['', [Validators.required, Validators.pattern(this.PatternsRegex.onlyEmail)]],
            numero_telefono: ['', [Validators.required, Validators.pattern(this.PatternsRegex.onlyNumberPhone), Validators.minLength(9), Validators.maxLength(9)]],
          }));
          break;
      }
    }
  }

  private clearControlValidators(group: FormGroup, fieldNames: string[]): void {
    fieldNames.forEach(field => {
      const control = group.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  omitirPaso(index: number, stepper: MatStepper): void {
    const group = this.getFormGroupAt(index);
    const tipoPregunta = this.formulario.tipo_pregunta[index].tipo_pregunta;
  
    switch (tipoPregunta) {
      case ListaTipoPregunta.TipoPregunta[0].codigo:
        // LISTA SELECCIONABLE
        this.clearControlValidators(group, ['opcion']);
        break;
  
      case ListaTipoPregunta.TipoPregunta[1].codigo:
        // BINARIA
        this.clearControlValidators(group, ['respuesta_binaria']);
        break;
  
      case ListaTipoPregunta.TipoPregunta[2].codigo:
        // SATISFACCION
        this.clearControlValidators(group, ['satisfaccion']);
        break;
  
      case ListaTipoPregunta.TipoPregunta[3].codigo:
        // OPINIÓN
        this.clearControlValidators(group, ['comentario']);
        break;
  
      case ListaTipoPregunta.TipoPregunta[4].codigo:
        // DATOS PERSONALES
        this.clearControlValidators(group, [
          'nombres',
          'apellido_paterno',
          'apellido_materno',
          'sexo',
          'correo_electronico',
          'numero_telefono'
        ]);
        break;
  
      default:
        break;
    }
  
    stepper.next();
  }

  

  getFormGroupAt(index: number): FormGroup {
    return this.steps.at(index) as FormGroup;
  }



  validandoFechaHora(horario:CHorario, dia:string, hora:number){
    let resultado = horario.dias.includes(dia);
    const horaValida = this.estaEnRango(hora,horario.hora_inicio, horario.hora_final)
    let result = resultado && horaValida? true: false;
    return result;
  }

  estaEnRango(horaActual: number, horaInicioStr: string, horaFinStr: string): boolean {
    const [hIni, mIni] = horaInicioStr.split(":").map(Number);
    const [hFin, mFin] = horaFinStr.split(":").map(Number);
  
    const minutosInicio = hIni * 60 + mIni;
    const minutosFin = hFin * 60 + mFin;
    const minutosActual = horaActual * 60;
  
    if (minutosInicio <= minutosFin) {
      // Rango dentro del mismo día
      return minutosActual >= minutosInicio && minutosActual <= minutosFin;
    } else {
      // Rango que cruza medianoche
      return minutosActual >= minutosInicio || minutosActual <= minutosFin;
    }
  }

  irEncuesta(){
    this.visible1= false;
    this.visible2 = true;
  } 

  finalizarEncuesta(): void {
    const controles:string[]=['codigo_mozo','respuesta_binaria','satisfaccion','comentario','']
    const respuestas: any[] = this.steps.value;
    let listaRespuesta:RespuestaFormulario[] =  [];
    let contador=0;
    let respuesta:CabeceraRespuesta = new CabeceraRespuesta();
    let listaRespuestasItem: RespuestaFormulario[]=[];
    while(contador<this.formulario.tipo_pregunta.length){
      const tipoPregunta = this.formulario.tipo_pregunta[contador].tipo_pregunta;      
      let rsptaItem:RespuestaFormulario =  new RespuestaFormulario();
      rsptaItem.tipo_pregunta = tipoPregunta;
      rsptaItem.codigo_pregunta = this.formulario.tipo_pregunta[contador].codigo_pregunta;
      switch(tipoPregunta){
        case 1:{
          rsptaItem.opcion_seleccionada = respuestas[contador].opcion;   
          break;
        }
        case 2:{
          rsptaItem.binaria = respuestas[contador].respuesta_binaria;
          break;
        }
        case 3:{
          rsptaItem.satisfaccion = respuestas[contador].satisfaccion;          
          break;
        }
        case 4:{
          rsptaItem.comentario = respuestas[contador].comentario;              
          break;
        }
        case 5:{
          const cliente:CCliente = new CCliente();
          cliente.nombres = respuestas[contador].nombres;
          cliente.apellido_paterno = respuestas[contador].apellido_paterno;
          cliente.apellido_materno = respuestas[contador].apellido_materno;
          cliente.correo_electronico = respuestas[contador].correo_electronico;
          cliente.numero_telefono = respuestas[contador].numero_telefono;
          cliente.sexo = respuestas[contador].sexo;
          rsptaItem.cliente = cliente;          
          break;
        }
        default:{
          break;
        }
  
      }
      listaRespuestasItem.push(rsptaItem);
      contador+=1;
    }
    respuesta.respuesta = listaRespuestasItem;
    this.spinnerPageService.show();
    this.encuestaBl.insertRespuestaEncuesta(this.formulario.id!, respuesta).then(res=>{
      if(res){
        this.spinnerPageService.hide();
        this.uiService.ShowSnackBar(SnackBarType.SUCCESS, Msjs.MSJ_GUARDADO_OK, 5000);
        this.steps.reset();
        this.visible1= true;
        this.visible2 = false;
      }
      else{
        this.spinnerPageService.hide();
        this.uiService.ShowSnackBar(SnackBarType.ERROR, Msjs.MSJ_ERROR_DESCONOCIDO, 5000);
      }
   
    })

  
  }
  

}
